import { ORANGE_COLORS } from '@junglescout/styles-library'
import { IColor } from 'styled-components'

export const COLORS: IColor = ORANGE_COLORS
